import React, { createContext, useContext, useState, useEffect } from 'react';
import supabase from '../supabaseClient';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = sessionStorage.getItem('hms_auth_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (userData, role) => {
    // Normaliser brukerobjektet for alle portaler
    const safeUserData = { ...userData };
    delete safeUserData.password;

    const sessionUser = {
      ...safeUserData,
      role: role || userData.role,
      // Sikre at ID-felt er konsistente
      id: userData.id,
      sellerId: userData.role === 'seller'
        ? (userData.seller_id || userData.sellerId || userData.id)
        : null,
      partnerId: userData.role === 'partner' ? (userData.partner_id || userData.partnerId) : null,
      companyId: userData.company_id || userData.companyId
    };

    setUser(sessionUser);
    sessionStorage.setItem('hms_auth_user', JSON.stringify(sessionUser));
    return true;
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('hms_auth_user');
  };

  const value = {
    user,
    isAuthenticated: !!user,
    loading,
    login,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
